import useIsMobile from "../hooks/useIsMobile";

export default function ResponsivePage({
  desktop: DesktopPage,
  mobile: MobilePage,
  desktopProps = {},
  mobileProps = {},
  desktopElement,
  mobileElement,
}) {
  const isMobile = useIsMobile();

  if (isMobile) {
    if (mobileElement) return mobileElement;
    return MobilePage ? <MobilePage {...mobileProps} /> : null;
  }

  if (desktopElement) return desktopElement;
  return DesktopPage ? <DesktopPage {...desktopProps} /> : null;
}

